var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3024.3 2630.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1622.1,
    y1: -829.5,
    x2: 1537.8,
    y2: 3298.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1b3864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1a3a64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#184168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#144d6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0f5f76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#097480"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 1602.5,
    y1: -829.9,
    x2: 1518.3,
    y2: 3297.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 1593.5,
    y1: -830.1,
    x2: 1509.3,
    y2: 3297.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 1231.7,
    y1: -837.5,
    x2: 1147.5,
    y2: 3290.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 1962.2,
    y1: -822.6,
    x2: 1878,
    y2: 3305.2,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M429.6,2159.1h237.9c15.6,0,29.3-9.1,35-23.6l51-123.7,660.7,414.5c20.6,12.2,43.4,18.3,65.8,18.3,41.9,0,82.6-20.2,107.3-57.5,8.4-12.6,14.1-26.6,17.5-40.7,20.6,12.2,43,18.3,65.5,18.3,41.5,0,82.2-20.2,107.3-57.1,12.9-19,19.8-40.7,20.9-63.2l11.4,6.9c20.6,12.6,43.8,18.6,66.2,18.6,41.5,0,82.2-20.2,107.3-57.1,11-16.4,17.9-34.3,20.2-53.7,19.8,11,41.5,16.7,62.8,16.7,41.9,0,82.6-20.2,107.3-57.5,16-24,22.5-51.8,20.9-78.8,52.9-20.6,110.7-44.5,175.4-72.3l69.6,169c5.7,14.1,19.8,23.6,35,23.6h237.9c20.9,0,38.1-17.1,38.1-38.1v-857.1c0-18.6-13.3-34.6-32-37.7-193-32-392.8-16.4-578.1,45.3l-11,3.8c-9.9,3.4-18.3,10.7-22.5,20.2-4.2,9.5-4.6,20.6-.8,30.4l55.2,134.3-387.8-169.7c-99.3-43.4-210.8-48.3-313.2-14.1-71.2,23.6-134.7,65.5-185,120.6-85.3-12.6-180.8-19.8-260.3-24l19.4-46.8c4.2-9.9,3.8-20.6-.8-30.4-4.6-9.9-12.6-16.7-22.5-20.2l-11-3.8c-185.3-61.7-385.5-77.6-578.1-45.3-18.3,3-32,19-32,37.7v856.3c0,20.9,17.1,38.1,38.1,38.1l1.1-.4ZM2675,1297.5v785.5h-174.3l-307.5-747.1c155.7-47.2,320.8-60.5,481.8-38.4ZM1485.3,1349.2c84.5-28.5,176.6-24.4,258.4,11.8l460.1,201.3,137.4,333.8c-63.6,27.8-120.6,51.4-172.8,71.2-6.5-8.4-14.1-16.7-22.8-23.6l-426.3-327.7c-87.2-67.7-207.4-79.2-305.6-29.7l-87.5,43.8c-18.3,9.5-43.4,5.7-59-9.9-16.7-16.7-19.8-42.6-7.6-63.2l30.4-51.4c44.1-73.8,113.8-129.4,195.2-156.8v.4ZM1224.2,1467.2l-30.1,50.6c-30.4,50.2-22.8,114.6,19,156,38.4,38.4,101.6,47.6,146.9,24l87.2-43.4c72.7-36.5,161-27.8,225.3,21.7l426.6,327.7c22.1,16.7,27,48,11.8,71.2-15.6,23.6-46.8,30.4-71.2,16l-401.5-240.9-39.2,65.1,315.9,189.5c9.1,9.1,14.1,21.3,14.1,35s-3,20.6-8.8,28.9c-16,23.6-47.2,30.4-71.2,16l-401.5-240.9-39.2,65.5,250,149.9,43.8,33.9c12.9,9.9,20.6,25.1,20.6,41.9s-3,20.6-8.8,28.9c-16,23.6-47.2,30.4-71.2,16l-401.5-240.9-39.2,65.5,328.4,196.8c1.1,4.2,1.9,8.8,1.9,13.7,0,10.7-3,20.6-8.8,29.3-15.6,23.6-46.8,30.4-70.4,16.7l-671-420.9,202.5-491.7c70,3,157.6,8.8,239,18.6l.4.4ZM467.6,1297.5c161-22.1,326.5-8.8,481.8,38.4l-307.5,747.1h-174.3v-785.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1255.1,695.4c-4.6,13.7-.8,28.9,9.5,39.2l125.6,122.5-29.7,173.2c-2.3,14.5,3.4,28.5,15.2,37.3,11.8,8.4,27.4,9.5,40,3l155.3-81.8,155.3,81.8c5.7,3,11.8,4.2,17.9,4.2s15.6-2.3,22.5-7.2c11.8-8.4,17.5-22.8,15.2-37.3l-29.7-173.2,125.6-122.5c10.3-10.3,14.1-25.1,9.5-39.2-4.6-13.7-16.4-24-30.8-25.9l-173.9-25.1-77.6-157.6c-12.9-25.9-55.6-25.9-68.1,0l-77.6,157.6-173.9,25.1c-14.5,1.9-26.3,12.2-30.8,25.9h.8ZM1490.3,716.7c12.6-1.9,23.2-9.5,28.5-20.9l52.5-106.2,52.5,106.2c5.7,11.4,16.4,19,28.5,20.9l117.2,17.1-84.9,82.6c-9.1,8.8-12.9,21.3-11,33.9l20.2,116.8-105-55.2c-5.7-3-11.8-4.2-17.9-4.2s-12.2,1.5-17.9,4.2l-105,55.2,20.2-116.8c2.3-12.2-1.9-25.1-11-33.9l-84.9-82.6,117.2-17.1h.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1571.3,161.1h0c21,0,38.1,17,38.1,38.1v114.2c0,21-17,38.1-38.1,38.1h0c-21,0-38.1-17-38.1-38.1v-114.2c0-21,17-38.1,38.1-38.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1213.2,497.5c12.9,16.4,36.9,19,53.7,6.1,16.4-12.9,19-36.9,6.1-53.7l-74.2-92.9c-12.9-16.4-36.9-19-53.7-6.1-16.7,12.9-19,36.9-6.1,53.7l74.2,92.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1929.5,497.5l74.2-92.9c12.9-16.4,10.7-40.3-6.1-53.7-16.7-13.3-40.3-10.3-53.7,6.1l-74.2,92.9c-12.9,16.4-10.7,40.3,6.1,53.7,16.4,12.9,40.3,10.3,53.7-6.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersIcon);
export default __webpack_public_path__ + "static/media/partners-icon.12f6d48650eeb72f9b056b6a4efcc1e3.svg";
export { ForwardRef as ReactComponent };